<template>
  <div>
    <el-row>
      <el-col>
        <rest-form-item :label="$t('ApplicationForm_Field_Title')" prop="name">
          <el-input v-model="model.name" data-qa="huawei-app-title-input" />
        </rest-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <rest-form-item
          :description="
            $t('ApplicationForm_Field_Huawei_App_ID_Description', {
              url: 'https://docs.xtremepush.com/docs/huawei-application'
            })
          "
          :label="$t('ApplicationForm_Field_Huawei_App_ID')"
          prop="huawei_app_id"
        >
          <el-input
            v-model="model.huawei_app_id"
            data-qa="huawei-app-id-input"
          />
        </rest-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="12">
        <rest-form-item
          prop="c"
          :label="$t('ApplicationForm_Field_AutoCreateEvents')"
        >
          <el-switch
            v-model="model.auto_create_events"
            :inactive-value="0"
            :active-value="1"
            data-qa="web-app-auto-create-events-switch"
          />
        </rest-form-item>
      </el-col>
      <el-col :span="12">
        <rest-form-item
          prop="c"
          :label="$t('ApplicationForm_Field_AutoCreateTags')"
        >
          <el-switch
            v-model="model.auto_create_tags"
            :inactive-value="0"
            :active-value="1"
            data-qa="web-app-auto-create-tags-switch"
          />
        </rest-form-item>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import RestFormItem from '@/common/components/rest/RestFormItem'

export default {
  name: 'AppAndroidHuaweiForm',
  components: { RestFormItem },
  props: {
    model: {
      required: true,
      type: Object
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/modules/account/components/AppAndroidHuaweiForm.vue